exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "html,\nbody,\n#canvas_wrap {\n  height: 100%;\n}\nbody {\n  display: flex;\n}\n#editor {\n  flex: 1;\n}\n#canvas_wrap {\n  position: relative;\n  flex: 2;\n}\n#canvas_wrap button {\n  position: absolute;\n  left: 10px;\n  top: 10px;\n}\n#canvas_wrap canvas {\n  margin: auto;\n  display: block;\n}\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/stylus-loader!./app/style.styl
 ** module id = 3
 ** module chunks = 0
 **/